import React from 'react';
import { Badge } from '../../ui/badge';

type PersonHeaderModel = {
  id: string;
  name: string;
  wpUserId?: string;
  type: 'student' | 'teacher' | 'both' | 'customer' | 'none';
  status: 'active' | 'inactive' | 'pending';
};

type Props = {
  person: PersonHeaderModel;
  profileTypeDescription: string;
  renderTypeIcon: (type: PersonHeaderModel['type']) => React.ReactNode;
  statusText: string;
  statusClassName: string;
};

export default function PersonDetailHeader({
  person,
  profileTypeDescription,
  renderTypeIcon,
  statusText,
  statusClassName,
}: Props) {
  const typeBadges: Array<{ label: string; className: string }> = [];
  if (person.type === 'student') {
    typeBadges.push({ label: 'Schüler', className: 'border-violet-300 bg-violet-50 text-violet-700' });
  } else if (person.type === 'teacher') {
    typeBadges.push({ label: 'Lehrer', className: 'border-emerald-300 bg-emerald-50 text-emerald-700' });
  } else if (person.type === 'both') {
    typeBadges.push({ label: 'Kunde', className: 'border-blue-300 bg-blue-50 text-blue-700' });
    typeBadges.push({ label: 'Lehrer', className: 'border-emerald-300 bg-emerald-50 text-emerald-700' });
  } else if (person.type === 'none') {
    // Im Office angelegt, noch ohne Registrierung und ohne Vertrag (T-0297).
    typeBadges.push({ label: 'Ohne Rolle', className: 'border-zinc-300 bg-zinc-50 text-zinc-600' });
  } else {
    typeBadges.push({ label: 'Kunde', className: 'border-blue-300 bg-blue-50 text-blue-700' });
  }

  return (
    <div className="flex flex-col items-start space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
      <div className="flex items-center space-x-4">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary text-4xl font-semibold text-primary-foreground">
          {(person.name || '?').charAt(0)}
        </div>
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-2xl font-semibold leading-7">{person.name}</h1>
            {typeBadges.map((badge) => (
              <Badge key={badge.label} variant="outline" className={badge.className}>
                {badge.label}
              </Badge>
            ))}
            <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${statusClassName}`}>
              {statusText}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            {renderTypeIcon(person.type)}
            <span className="text-muted-foreground">{profileTypeDescription}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
